import { Box } from 'braid-design-system';

import { Error } from 'src/components/Error/Error';
import { PaymentContainer } from 'src/components/PaymentContainer/PaymentContainer';

interface PaymentGenericErrorProps {
  testId: string;
}

export const PaymentGenericError = (props: PaymentGenericErrorProps) => (
  <PaymentContainer width="medium">
    <Box data={{ testid: props.testId }}>
      <Error />
    </Box>
  </PaymentContainer>
);
